import { render, staticRenderFns } from "./ZonesUpdate.vue?vue&type=template&id=d927af32"
import script from "./ZonesUpdate.vue?vue&type=script&lang=js"
export * from "./ZonesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports